<template>
<div class="d-flex">
  <input  :type="computedType"
          :name="name"
          :id="computedId"
          :class="computedClass"
          :checked="checked"
          :disabled="disabled"
          ref="input"
          @click="click($event)"
          @change="change($event)" />
  <label  :for="computedId"
          @click="click($event)"><slot v-if="$slots.default" /><span v-else>{{ label }}</span></label>
</div>
</template>

<script>
let idIndex = 0

export default {
  name: 'LkCheckboxBase',
  data () {
    return {
      innerId: ++idIndex
    }
  },
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    id: [ String, Number ],
    name: [ String, Number ],
    checked: Boolean,
    disabled: Boolean,
    label: String
  },
  mounted () {
    // для борьбы с bfcache (происходит рассинхронизация DOM c состоянием компонента)
    setTimeout(() => {
      // this.$refs.input.checked = this.checked
      try {
        if (this.checked !== this.$refs.input.checked) {
          this.$emit('change', this.$refs.input.checked)
        }
      } catch (ignored) {
        // хз, из-за чего именно происходит, но получается, когда резко переходим на новую страницу, когда еще что-то не догрузилось
      }
    }, 10)
  },
  computed: {
    computedId () {
      return this.id ? this.id : this.computedClass + '-' + (++idIndex)
    },
    computedType () {
      return this.innerType ? this.innerType : 'checkbox'
    },
    computedClass () {
      return this.innerClass ? this.innerClass : 'checkbox'
    }
  },
  methods: {
    click () {
      this.$emit('click')
    },
    change (event) {
      this.$emit('change', event.target.checked)
    }
  }
}
</script>
